import { css } from 'styled-components';

export const focusStyles = css`
  outline: 2px solid #005fcc !important;
  outline-offset: 2px;
  box-shadow: 0 0 0 2px #fff;
`;

export const focusVisibleMixin = css`
  &:focus-visible {
    ${focusStyles}
  }
`;
